export function initScrollAnimation(): void {
  setupAbout();
  setupPersonCardRows('.winners__grid');
  setupPersonCardRows('.advisory__grid');
  setupCriteriaCards();
  setupCeremony();
}

function createObserver(el: Element, onEnter: () => void, threshold = 0.1): void {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        onEnter();
        io.disconnect();
      }
    });
  }, { threshold });
  io.observe(el);
}

function setupAbout(): void {
  const targets = [
    document.querySelector('.about__lead'),
    document.querySelector('.about__body'),
  ];
  targets.forEach(el => {
    if (!el) return;
    el.classList.add('js-fade-up');
    createObserver(el, () => el.classList.add('is-visible'));
  });
}

function groupCardsByRow(cards: HTMLElement[]): HTMLElement[][] {
  const rows: HTMLElement[][] = [];
  let currentRow: HTMLElement[] = [];
  let lastTop = -Infinity;

  cards.forEach(card => {
    const top = Math.round(card.getBoundingClientRect().top + window.scrollY);
    if (currentRow.length === 0 || Math.abs(top - lastTop) < 5) {
      currentRow.push(card);
      lastTop = top;
    } else {
      rows.push(currentRow);
      currentRow = [card];
      lastTop = top;
    }
  });
  if (currentRow.length > 0) rows.push(currentRow);

  return rows;
}

function setupPersonCardRows(gridSelector: string): void {
  const cards = Array.from(
    document.querySelectorAll<HTMLElement>(`${gridSelector} .person-card`)
  );
  if (!cards.length) return;

  cards.forEach(card => card.classList.add('js-fade-up'));

  const rows = groupCardsByRow(cards);
  rows.forEach(row => {
    createObserver(row[0], () => row.forEach(card => card.classList.add('is-visible')));
  });
}

function setupCriteriaCards(): void {
  const container = document.querySelector('.criteria__cards');
  const cards = Array.from(document.querySelectorAll('.criteria-card'));
  if (!container || !cards.length) return;

  cards.forEach(card => card.classList.add('js-fade-up'));

  createObserver(container, () => {
    cards.forEach((card, i) => {
      setTimeout(() => card.classList.add('is-visible'), i * 150);
    });
  });
}

function setupCeremony(): void {
  const info = document.querySelector('.ceremony__info');
  if (!info) return;
  info.classList.add('js-fade-up');
  createObserver(info, () => info.classList.add('is-visible'));
}
